'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EmailPreferenceToggle = require('../../../workspace/header/utils/account/email/EmailPreferenceToggle');

var _EmailPreferenceToggle2 = _interopRequireDefault(_EmailPreferenceToggle);

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _PrimarySuccessMessage = require('../../../components/form/messages/PrimarySuccessMessage');

var _PrimarySuccessMessage2 = _interopRequireDefault(_PrimarySuccessMessage);

var _accountConstants = require('../accountConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateSubscriptionsView = function UpdateSubscriptionsView(props) {
    var updatePreference = props.updatePreference,
        emailPreference = props.emailPreference,
        savedEmailPreference = props.savedEmailPreference,
        loading = props.loading,
        savePreferences = props.savePreferences,
        submitted = props.submitted,
        dirty = props.dirty;


    var changesMade = emailPreference !== savedEmailPreference;
    var changesSaved = submitted && !dirty && !changesMade;

    return _react2.default.createElement(
        'div',
        { className: 'Subscriptions UpdateSubscriptionsView' },
        _react2.default.createElement(
            'h2',
            null,
            'Update subscriptions'
        ),
        _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
                'p',
                null,
                'Choose what you\'d like to be notified about then click "Save preferences":'
            ),
            _react2.default.createElement(
                'ul',
                { className: 'option-list' },
                _accountConstants.EMAIL_PREFERENCE_CHECKLIST.map(function (emailPreferenceEntry) {
                    return _react2.default.createElement(_EmailPreferenceToggle2.default, {
                        key: emailPreferenceEntry.value,
                        updatePreference: updatePreference,
                        active: !!(emailPreference & emailPreferenceEntry.value),
                        value: emailPreferenceEntry.value,
                        label: emailPreferenceEntry.label });
                })
            ),
            _react2.default.createElement(
                _FormButton2.default,
                { className: 'primary', onClickFn: savePreferences, disabled: loading || submitted && !dirty },
                'Save preferences'
            ),
            _react2.default.createElement(_PrimarySuccessMessage2.default, { message: 'Your subscription preferences have been saved', show: changesSaved })
        )
    );
};

UpdateSubscriptionsView.propTypes = {
    updatePreference: _propTypes2.default.func.isRequired,
    emailPreference: _propTypes2.default.number.isRequired,
    savedEmailPreference: _propTypes2.default.number.isRequired,
    loading: _propTypes2.default.bool,
    savePreferences: _propTypes2.default.func.isRequired,
    isGuest: _propTypes2.default.bool,
    dispatchNavigateToRootWorkspace: _propTypes2.default.func.isRequired,
    dispatchNavigateToLogin: _propTypes2.default.func.isRequired,
    submitted: _propTypes2.default.bool,
    dirty: _propTypes2.default.bool
};

exports.default = UpdateSubscriptionsView;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/UpdateSubscriptionsView.js
// module id = 2085
// module chunks = 0